import { User } from '../../types/auth.types';

import {
  LoginAction,
  SignupAction,
  ForgotPasswordAction,
  ResetPasswordAction,
  LogoutAction,
  AuthActionTypes,
  ResetAuthAction,
  LogoutSuccessAction,
  LogoutErrorAction,
  LoginSuccessAction,
  LoginErrorAction,
  SignupSuccessAction,
  SignupErrorAction,
  ForgotPasswordSuccessAction,
  ForgotPasswordErrorAction,
  ResetPasswordSuccessAction,
  ResetPasswordErrorAction,
} from './auth.types';

export const authActions = {
  // Login
  login: (username: string, password: string): LoginAction => ({
    type: AuthActionTypes.LOGIN_USER,
    payload: { username, password },
  }),
  loginSuccess: (user: User): LoginSuccessAction => ({
    type: AuthActionTypes.LOGIN_SUCCESS,
    user,
  }),
  loginError: (error: string): LoginErrorAction => ({
    type: AuthActionTypes.LOGIN_ERROR,
    error,
  }),

  // Signup
  signup: (email: string, password: string, fullname: string): SignupAction => ({
    type: AuthActionTypes.SIGNUP_USER,
    payload: { email, password, fullname },
  }),
  signupSuccess: (): SignupSuccessAction => ({
    type: AuthActionTypes.SIGNUP_SUCCESS,
  }),
  signupError: (error: string): SignupErrorAction => ({
    type: AuthActionTypes.SIGNUP_ERROR,
    error,
  }),

  // Forgot Password
  forgotPassword: (email: string): ForgotPasswordAction => ({
    type: AuthActionTypes.FORGOT_PASSWORD,
    payload: { email },
  }),
  forgotPasswordSuccess: (): ForgotPasswordSuccessAction => ({
    type: AuthActionTypes.FORGOT_PASSWORD_SUCCESS,
  }),
  forgotPasswordError: (error: string): ForgotPasswordErrorAction => ({
    type: AuthActionTypes.FORGOT_PASSWORD_ERROR,
    error,
  }),

  // Reset Password
  resetPassword: (newPassword: string, token: string, id: string): ResetPasswordAction => ({
    type: AuthActionTypes.FORGOT_PASSWORD_CHANGE,
    payload: { newPassword, token, id },
  }),
  resetPasswordSuccess: (): ResetPasswordSuccessAction => ({
    type: AuthActionTypes.FORGOT_PASSWORD_CHANGE_SUCCESS,
  }),
  resetPasswordError: (error: string): ResetPasswordErrorAction => ({
    type: AuthActionTypes.FORGOT_PASSWORD_CHANGE_ERROR,
    error,
  }),

  // Logout
  logout: (): LogoutAction => ({
    type: AuthActionTypes.LOGOUT_USER,
  }),
  logoutSuccess: (): LogoutSuccessAction => ({
    type: AuthActionTypes.LOGOUT_SUCCESS,
  }),
  logoutError: (error: string): LogoutErrorAction => ({
    type: AuthActionTypes.LOGOUT_ERROR,
    error,
  }),

  // Reset
  resetAuth: (): ResetAuthAction => ({
    type: AuthActionTypes.RESET,
  }),
};
